import { createPromiseAction } from 'redux-saga-promise-actions';
import { QrCodePayload, QrCodeResponse } from 'store/types/qrCode';

export const getQRCode = createPromiseAction('GET_QRCODE', 'GET_QRCODE_SUCCEEDED', 'GET_QRCODE_FAILURE')<
  QrCodePayload,
  QrCodeResponse,
  undefined
>();
